export default __webpack_public_path__ + "static/media/WITW_intro.37d1c95e.mp3";